module.exports = __webpack_public_path__ + "img/partner9.cc450ad0.png";